import React from "react";
import hero from "../assets/hero.jpg";
import about1 from '../assets/about1.jpg'
import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {

  const navigate = useNavigate();

  return (
    <section className="py-5 about-section">
      <div className="container">

        {/* Section Title */}
        <div className="text-center mb-5">
          <h6 className="text-uppercase text-primary fw-bold mb-3">ABOUT US</h6>
          <h1 className="fw-bold display-6 about-title raleway">
            Empowering Women with Tailored Loans and Financial Solutions for Growth and Independence
          </h1>
        </div>

        {/* Main Content Row */}
        <div className="row align-items-center">

          {/* LEFT IMAGE BLOCK */}
          <div className="col-lg-6 position-relative mb-5 mb-lg-0">

            {/* Large main image */}
            <img
              src={about1}
              alt="Main discussion"
              className="img-fluid main-img rounded shadow"
            />

            {/* Small overlay image */}
            <div className="small-img-wrapper rounded shadow tilt-img">
              <img
                src={hero}
                alt="Mortgage signing"
                className="img-fluid rounded"
              />
            </div>
          </div>

          {/* RIGHT TEXT CONTENT */}
          <div className="col-lg-6">
            <p className="lead">
              Get quick, flexible, and hassle-free loans tailored for women — whether it’s personal, business, housing, or consumer needs. Your financial freedom starts here.
            </p>

            <ul className="list-unstyled mt-4">
              <li className="mb-3 d-flex align-items-center">
                <i className="bi bi-check-circle-fill text-primary me-2"></i>
                <FaCheck className="text-info me-2" /> Empowering women with tailored financial solutions
              </li>
              <li className="mb-3 d-flex align-items-center">
                <i className="bi bi-check-circle-fill text-primary me-2"></i>
                <FaCheck className="text-info me-2" /> Quick approvals with minimal documentation required
              </li>
              <li className="mb-3 d-flex align-items-center">
                <i className="bi bi-check-circle-fill text-primary me-2"></i>
                <FaCheck className="text-info me-2" /> Flexible loans for personal and business needs
              </li>
              <li className="mb-3 d-flex align-items-center">
                <i className="bi bi-check-circle-fill text-primary me-2"></i>
                <FaCheck className="text-info me-2" /> Trusted partner for financial growth journey
              </li>
            </ul>

            <button className="btn btn-info btn-lg mt-3 text-white" onClick={() => navigate('/contact')}>Contact Us</button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutUs;
